import { ChangeDetectionStrategy, Component, ContentChild, ContentChildren, Input, QueryList } from '@angular/core';
import { BoschUiRowDefDirective } from './directives/bosch-ui-row-def.directive';
import { BoschUiTableService } from './bosch-ui-table.service';
import { BoschUiHeaderRowDefDirective } from './directives/bosch-ui-header-row-def.directive';
import { BoschUiTableDataSource } from './entities/bosch-ui-table-data-source.entity';
import { Observable } from 'rxjs';

// TODO: things to be done
// - add soring
// - add dynamic columns
@Component({
  selector: 'bosch-ui-table',
  templateUrl: './bosch-ui-table.component.html',
  styleUrls: ['./bosch-ui-table.component.scss'],
  providers: [BoschUiTableService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiTableComponent<DataType> {
  @Input() set dataSource(dataSource: BoschUiTableDataSource<DataType> | DataType[]) {
    if (dataSource) {
      this.tableService.dataSource = dataSource;
    }
  }

  data$: Observable<DataType[]> = this.tableService.data$;

  @ContentChildren(BoschUiRowDefDirective, { descendants: true })
  public rows!: QueryList<BoschUiRowDefDirective<DataType>>;

  @ContentChild(BoschUiHeaderRowDefDirective, { descendants: true })
  public headerRow!: BoschUiHeaderRowDefDirective<DataType>;

  constructor(protected tableService: BoschUiTableService<DataType>) {}

  trackByDataFn(index: number): string {
    return `table_data_${index}`;
  }

  trackByRowFn(index: number): string {
    return `table_row_${index}`;
  }
}
